import React, { useState } from 'react';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface AvatarProps {
  name: string;
  src?: string;
  size?: AvatarSize;
  className?: string;
}

const SIZE_MAP: Record<AvatarSize, { box: string; text: string }> = {
  xs: { box: 'w-6 h-6', text: 'text-2xs' },
  sm: { box: 'w-8 h-8', text: 'text-xs' },
  md: { box: 'w-10 h-10', text: 'text-sm' },
  lg: { box: 'w-12 h-12', text: 'text-md' },
  xl: { box: 'w-16 h-16', text: 'text-lg' },
};

const initialsOf = (name: string): string => {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0 || !parts[0]) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const Avatar: React.FC<AvatarProps> = ({ name, src, size = 'md', className = '' }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const sz = SIZE_MAP[size];
  const showImage = src && !imageFailed;
  return (
    <div
      className={`${sz.box} rounded-full overflow-hidden bg-pt-sage flex items-center justify-center shrink-0 ${className}`.trim()}
      aria-label={name}
    >
      {showImage ? (
        <img
          src={src}
          alt={name}
          className="w-full h-full object-cover"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span className={`${sz.text} font-semibold text-pt-forest`}>{initialsOf(name)}</span>
      )}
    </div>
  );
};

export default Avatar;
